(() => {
  if (window.pwCollectionFilterCleanup) return;
  window.pwCollectionFilterCleanup = true;
  const colorKey = 'filter.v.option.color';
  const materialKey = 'filter.v.m.custom.material';
  const fitsKey = 'filter.p.m.custom.what_fits';
  const groups = {
    Taupe: ['Taupe', 'Taupe Suede', 'Earl Grey', 'Cream Earlgrey', 'Taupe Brown', 'Brown Taupe', 'Taupe Pebble'],
    Black: ['Black', 'Black Suede', 'Brown Black', 'Black Brown', 'Canvas Black', 'Houndstooth', 'Cream Black', 'Black Pebble', 'Black Silver'],
    Brown: ['Brown', 'Chocolate Suede', 'Brown Suede', 'Chai', 'Chocolate', 'Camel', 'Cappuccino', 'Chestnut', 'Beige', 'Beige Houndstooth', 'Canvas brown', 'Black brown', 'Brown Cream'],
    Cream: ['Cream', 'Cream Suede', 'Audrey Top Handle-Bamboo', 'Cream Black'],
    Burgundy: ['Burgundy', 'Burgundy Suede', 'Maroon'], Grey: ['Grey', 'Parisian Grey', 'Plaid'],
    Raffia: ['Raffia', 'Bamboo'], Others: ['Pink', 'Green', 'Dream Blue', 'Icy', 'Red', 'Lavender', 'Brown Houndstooth'],
    Multi: ['Multi', 'Canvas Brown'], Gold: ['Gold Vermeil', 'Gold plated Brass']
  };
  const norm = value => String(value ?? '').replace(/^new-/, '').trim().toLowerCase();
  const values = value => (Array.isArray(value) ? value : value == null ? [] : [value]).map(norm);
  let products;
  let loading;
  let scheduled = false;
  const countLabel = (count) => new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
  function refresh() {
    if (!products) return;
    const params = new URLSearchParams(location.search);
    const selected = { [colorKey]: params.getAll(colorKey).map(norm), [materialKey]: params.getAll(materialKey).map(norm), [fitsKey]: params.getAll(fitsKey).map(norm) };
    function countFor(key, choices) {
      const state = { ...selected, [key]: choices.map(norm) };
      return products.filter(product => {
        if (state[fitsKey].length && !state[fitsKey].some(v => values(product.fits).includes(v))) return false;
        return product.variants.some(variant => {
          if (state[colorKey].length && !state[colorKey].includes(norm(variant.color))) return false;
          if (state[materialKey].length && !state[materialKey].some(v => values(variant.material).includes(v))) return false;
          return true;
        });
      }).length;
    }
    document.querySelectorAll('.facets-container input[type="checkbox"]').forEach(input => {
      if (input.id.includes('Hidden-Filter')) return;
      const grouped = input.dataset.filterGroup;
      const key = grouped ? colorKey : input.name;
      if (![colorKey, materialKey, fitsKey].includes(key)) return;
      const choices = grouped ? groups[grouped] || [grouped] : [input.value];
      const count = countFor(key, choices);
      const label = input.closest('label');
      const row = label?.closest('li');
      if (!label || !row) return;
      const active = input.checked;
      row.hidden = count === 0 && !active;
      row.toggleAttribute('data-pw-empty-choice', count === 0 && !active);
      input.disabled = count === 0 && !active;
      label.classList.toggle('facet-checkbox--disabled', input.disabled);
      label.classList.toggle('mobile-facets__label--disabled', input.disabled);
      let badge = label.querySelector('.pw-filter-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'pw-filter-count';
        badge.setAttribute('aria-hidden', 'true');
        label.append(badge);
      }
      const text = `(${countLabel(count)})`;
      if (badge.textContent !== text) badge.textContent = text;
      const title = grouped || input.value;
      const accessibleText = `${title} (${countLabel(count)})`;
      input.setAttribute('aria-label', accessibleText);
      const oldCount = label.querySelector('.visually-hidden');
      if (oldCount && oldCount.textContent !== accessibleText) oldCount.textContent = accessibleText;
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  }
  function load() {
    if (products) { schedule(); return; }
    if (loading) return;
    const container = document.querySelector('[data-pw-filter-url]');
    const base = container?.dataset.pwFilterUrl;
    if (!base || !base.includes('/collections/')) return;
    const url = new URL(base, location.origin);
    url.search = 'section_id=pw-collection-filter-index';
    loading = fetch(url, { credentials: 'same-origin' })
      .then(response => { if (!response.ok) throw new Error('Filter data unavailable'); return response.text(); })
      .then(html => {
        const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pw-filter-index]');
        if (!data) throw new Error('Filter data missing');
        products = JSON.parse(data.textContent);
        refresh();
      })
      .catch(() => { loading = undefined; });
  }
  document.addEventListener('click', event => { if (event.target.closest('.facets-container')) load(); });
  document.addEventListener('focusin', event => { if (event.target.closest('.facets-container')) load(); });
  document.addEventListener('toggle', event => { if (event.target.closest?.('.facets-container') && event.target.open) load(); }, true);
  document.addEventListener('pw:filters-updated', schedule);
  window.addEventListener('popstate', schedule);
})();
